import Nomination_1 from 'assets/images/content/nomination/1.png';
import Nomination1m from 'assets/images/content/nomination/icon_m_1.png';
import Nomination1 from 'assets/images/content/nomination/icon_1.png';
import Nomination3m from 'assets/images/content/nomination/icon_m_3.png';
import Nomination3 from 'assets/images/content/nomination/icon_3.png';
import Nomination5m from 'assets/images/content/nomination/icon_m_5.png';
import Nomination5 from 'assets/images/content/nomination/icon_5.png';
import Nomination6m from 'assets/images/content/nomination/icon_m_6.png';
import Nomination6 from 'assets/images/content/nomination/icon_6.png';
import Pdf1 from 'assets/pdf/Polojenie-luchshiy-dom.pdf';
import Doc from 'assets/images/svg/icon_doc.svg';
import Pdf2 from 'assets/pdf/ER-pres-KonkursZHKKH.pdf';

export const Nomination = () => {
    return (
        <section className='nomination'>
            <div className='container'>
                <h2 className='nomination__title title'>Номинации конкурса</h2>
                <div className='nomination__d-flex'>
                    <div className='nomination__block'>
                        <div className='nomination__list'>
                            <div className='nomination__item'>
                                <div className='nomination__icon'>
                                    <picture>
                                        <source
                                            media='(max-width: 768px)'
                                            srcSet={Nomination1m}
                                        />
                                        <img src={Nomination1} alt='' />
                                    </picture>
                                </div>
                                <p className='nomination__text text-s24'>
                                    Самый энергоэффективный дом
                                </p>
                            </div>

                            <div className='nomination__item'>
                                <div className='nomination__icon'>
                                    <picture>
                                        <source
                                            media='(max-width: 768px)'
                                            srcSet={Nomination3m}
                                        />
                                        <img src={Nomination3} alt='' />
                                    </picture>
                                </div>
                                <p className='nomination__text text-s24'>Самый дружный дом</p>
                            </div>

                            <div className='nomination__item'>
                                <div className='nomination__icon'>
                                    <picture>
                                        <source
                                            media='(max-width: 768px)'
                                            srcSet={Nomination5m}
                                        />
                                        <img src={Nomination5} alt='' />
                                    </picture>
                                </div>
                                <p className='nomination__text text-s24'>Лучший подъезд</p>
                            </div>
                            <div className='nomination__item'>
                                <div className='nomination__icon'>
                                    <picture>
                                        <source
                                            media='(max-width: 768px)'
                                            srcSet={Nomination6m}
                                        />
                                        <img src={Nomination6} alt='' />
                                    </picture>
                                </div>
                                <p className='nomination__text text-s24'>Лучший двор</p>
                            </div>
                        </div>
                    </div>
                    <div className='nomination__block'>
                        <div className='nomination__img'>
                            <picture>
                                <img src={Nomination_1} alt='' />
                            </picture>
                        </div>
                    </div>
                </div>
                <div className='nomination__bottom'>
                    <p className='nomination__desc'>
                        Количество победителей в каждой номинации определяется решением организационного комитета
                    </p>
                    <p className='nomination__desc'>
                        Организационный комитет по предложению жюри Конкурса может учредить дополнительные номинации, которые позволят отметить выдающиеся заслуги участников, выходящие за тематику номинаций Конкурса.
                    </p>

                    <div className='nomination__files'>
                        <a
                            href={Pdf1}
                            target={'_blank'}
                            rel='noreferrer'
                            className='nomination__file'
                        >
                            <span>Положение о конкурсе</span>
                            <img src={Doc} alt='' />
                        </a>
                        <a
                            href={Pdf2}
                            target={'_blank'}
                            rel='noreferrer'
                            className='nomination__file'
                        >
                            <span>Презентация о конкурсе</span>
                            <img src={Doc} alt='' />
                        </a>
                        {/*<a*/}
                        {/*    href={Pdf3}*/}
                        {/*    target={'_blank'}*/}
                        {/*    rel='noreferrer'*/}
                        {/*    className='nomination__file'*/}
                        {/*>*/}
                        {/*    <span>Методика оценки</span>*/}
                        {/*    <img src={Doc} alt='' />*/}
                        {/*</a>*/}
                    </div>
                </div>
            </div>
        </section>
    )
}
